import { alpha } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      fontWeight: 500,
      gap: theme.spacing(0.5),
    },
    total: {
      fontSize: '36px',
      lineHeight: theme.spacing(5.5),
      fontWeight: 400,
      color: theme.palette.labraText.primary,
      paddingRight: theme.spacing(2),
    },
    currency: {
      fontWeight: 400,
      fontSize: theme.spacing(2.75),
      lineHeight: theme.spacing(3.5),
      paddingTop: theme.spacing(1),
      color: theme.palette.text.tertiary,
    },
    percentage: {
      background: alpha(theme.palette.textBackground.dark, 0.11),
      padding: theme.spacing(0.25, 0.875, 0.25, 0.875),
      borderRadius: theme.spacing(0.5),
      marginTop: theme.spacing(1),
    },
  }
})
